import TextField, { TextFieldProps } from '@mui/material/TextField';
import React, { useEffect } from 'react';
import { NumberFormatBase } from 'react-number-format';

function currencyFormatter(value: any) {
  if (!Number(value)) return '';

  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value / 100);

  return `${amount}`;
}

function NumberFormatCustom({ inputRef, onChange, value, ...props }: any) {
  const [internalValue, setInternalValue] = React.useState('');

  useEffect(() => {
    setInternalValue(value);
  }, []);

  return (
    <NumberFormatBase
      value={internalValue}
      onValueChange={(values) => {
        setInternalValue(values.value);
        onChange({
          target: {
            name: props.name,
            value: String(Number(values.value) / 100),
          },
        });
      }}
      getInputRef={inputRef}
      format={currencyFormatter}
      thousandSeparator="."
      decimalSeparator=","
      isNumericString
      {...props}
    />
  );
}

const InputCurrencyBase: React.ForwardRefRenderFunction<any, TextFieldProps> = (
  props,
  ref,
) => {
  return (
    <TextField
      variant="outlined"
      color="primary"
      fullWidth
      InputProps={{
        inputComponent: NumberFormatCustom as any,
      }}
      autoComplete="off"
      inputRef={ref}
      {...props}
    />
  );
};

const InputCurrency = React.forwardRef(InputCurrencyBase);

export default InputCurrency;
